/**
 * @ming
 * https://turing.atlassian.net/browse/VET2-1115
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultComponent from './Default';
import BasicInfoComponent from './BasicInfo';
import ExperienceComponent from './Experience';
import AddProjectComponent from './AddProject';
import BuildComponent from './Build';
import CertificationAwardComponent from './CertificationAward';
import FavoriteProjectComponent from './FavoriteProject';
import OutcomeComponent from './Outcome';
import PublicationsComponent from './Publications';
import RoleComponent from './Role';
import SummaryComponent from './Summary';
import ClearIcon from '@material-ui/icons/Clear';
import { connect } from 'react-redux';
import './rightSidebar.css';
import { CONTENT_IDS } from '../../legacy_components/constants';

const RightSidebar = ({ preTestCommon, isOnboarding }) => {
  const [visibleSidebar, showSidebar] = useState(true);
  let sidebarComponent;
  const contentId = preTestCommon.contentId || CONTENT_IDS.default;
  const displayMode = preTestCommon.displayMode || 'default';
  switch (contentId) {
    case CONTENT_IDS.basicInfo: {
      sidebarComponent = <BasicInfoComponent/>;
      break;
    }
    case CONTENT_IDS.experience: {
      sidebarComponent = <ExperienceComponent/>;
      break;
    }
    case CONTENT_IDS.helpAddProject: {
      sidebarComponent = <AddProjectComponent/>;
      break;
    }
    case CONTENT_IDS.helpBuild: {
      sidebarComponent = <BuildComponent/>;
      break;
    }
    case CONTENT_IDS.helpCertificationAward: {
      sidebarComponent = <CertificationAwardComponent/>;
      break;
    }
    case CONTENT_IDS.helpFavoriteProject: {
      sidebarComponent = <FavoriteProjectComponent/>;
      break;
    }
    case CONTENT_IDS.helpOutcome: {
      sidebarComponent = <OutcomeComponent/>;
      break;
    }
    case CONTENT_IDS.helpPublications: {
      sidebarComponent = <PublicationsComponent/>;
      break;
    }
    case CONTENT_IDS.helpRole: {
      sidebarComponent = <RoleComponent/>;
      break;
    }
    case CONTENT_IDS.helpSummary: {
      sidebarComponent = <SummaryComponent/>;
      break;
    }
    case CONTENT_IDS.default:
    default: {
      sidebarComponent = <DefaultComponent isOnboardingDefault={isOnboarding}/>;
      break;
    }
  }

  const handleClose = () => {
    showSidebar(false);
  };

  return (
    <div className={'right-sidebar' + (displayMode === 'mobile' ? ' sidebar-full' : '')} style={{ display: (visibleSidebar ? 'block' : 'none') }}>
      <ClearIcon className="close-sidebar" onClick={handleClose} style={{ display: (displayMode === 'mobile' ? 'block' : 'none') }}/>
      {sidebarComponent}
      {preTestCommon.showOverlay && <div className="overlay-background"></div>}
    </div>
  );
};

RightSidebar.BasicInfoComponent = BasicInfoComponent;
RightSidebar.ExperienceComponent = ExperienceComponent;
RightSidebar.AddProjectComponent = AddProjectComponent;
RightSidebar.BuildComponent = BuildComponent;
RightSidebar.CertificationAwardComponent = CertificationAwardComponent;
RightSidebar.FavoriteProjectComponent = FavoriteProjectComponent;
RightSidebar.OutcomeComponent = OutcomeComponent;
RightSidebar.PublicationsComponent = PublicationsComponent;
RightSidebar.RoleComponent = RoleComponent;
RightSidebar.SummaryComponent = SummaryComponent;
RightSidebar.DefaultComponent = DefaultComponent;

const mapStateToProps = (store) => ({ preTestCommon: store.preTestCommon });

RightSidebar.propTypes = {
  preTestCommon: PropTypes.object,
  isOnboarding: PropTypes.bool
};

export default connect(mapStateToProps, null)(RightSidebar);
